'use client'

import { m } from 'framer-motion'
import { MapPin, Navigation } from 'lucide-react'

import { COMPANY_YANDEX_MAPS_URL } from '@/lib/seo'

export default function ContactsLocation() {
  const officeCard = (
    <div className="relative w-full overflow-hidden rounded-[28px] border border-white/10 bg-[#0a0f1a]/80 p-6 shadow-[0_20px_60px_rgba(0,0,0,0.5)] backdrop-blur-2xl sm:max-w-md sm:rounded-[40px] sm:p-8 md:p-10">
      <div className="pointer-events-none absolute top-0 right-0 h-[200px] w-[200px] rounded-full bg-blue-500/10 blur-[80px]" />

      <div className="relative z-10">
        <div className="mb-8 flex items-center gap-5">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-gradient-to-br from-blue-500/20 to-purple-500/20">
            <MapPin className="h-8 w-8 text-white" />
          </div>
          <div>
            <h3 className="home-card-title-sm mb-1 text-white">Главный офис</h3>
            <p className="home-subnote tracking-wide text-gray-400">Майкоп, Россия</p>
          </div>
        </div>

        <div className="home-subnote mb-10 space-y-2 text-gray-200">
          <p className="font-medium">ул. Степная</p>
          <p className="text-gray-400">Республика Адыгея</p>
        </div>

        <a
          href={COMPANY_YANDEX_MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-white py-5 text-lg font-bold text-black shadow-lg transition-colors hover:bg-gray-200"
        >
          <Navigation className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          Построить маршрут
        </a>
      </div>
    </div>
  )

  return (
    <section id="map" className="relative py-14 sm:py-20">
      <div className="home-container">
        <m.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative h-[520px] overflow-hidden rounded-[28px] border border-white/5 bg-[#0c1220] shadow-2xl sm:h-[650px] sm:rounded-[48px] md:h-[800px]"
        >
          <div className="pointer-events-none absolute inset-0 z-10 bg-[#0a0f1a] mix-blend-color" />

          <iframe
            src="https://yandex.ru/map-widget/v1/?um=constructor%3A0b45763567794350171279061091219904791054904077598806544974797089&amp;source=constructor"
            width="100%"
            height="100%"
            frameBorder="0"
            loading="lazy"
            className="opacity-70 grayscale invert transition-opacity duration-1000 hover:opacity-100"
            style={{ filter: 'invert(92%) hue-rotate(180deg) contrast(1.1) brightness(0.9)' }}
          />

          <div className="pointer-events-none absolute inset-0 z-20 shadow-[inset_0_0_150px_rgba(10,15,26,0.9)]" />

          <m.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="absolute bottom-10 left-6 z-30 hidden sm:block md:bottom-20 md:left-20"
          >
            {officeCard}
          </m.div>
        </m.div>

        <div className="mt-6 sm:hidden">{officeCard}</div>
      </div>
    </section>
  )
}
